<template>
    <transition name="el-zoom-in-top">
        <div class="content-wrapper">
       <!-- Content Header (Page header) -->
        <section class="content-header">
            <!-- <h1>Toko<small>It's all start from here <i class="ti-heart"></i><i class="ti-export"></i><i class="ti-printer"></i></small></h1> -->
            <ol class="breadcrumb">
                <li><router-link to="/"> <i class="ti-home"></i></router-link></li>
                <li><a href="#">Toko</a></li>
                <li><a href="#/pemesanan_barang">Pemesanan Barang</a></li>
            </ol>
        </section>
  
            <!-- Main content -->
            <section class="content">
               <!-- Basic Tables-->
                <div class="box">
                    <div class="box-header with-border">
                        <div class="pull-left" style="padding-left: 20px; padding-top: 10px;">
                          <h4><b>PEMESANAN BARANG</b></h4>
                        </div> 
                        <div class="pull-right" style="padding-right: 20px; padding-top: 10px;">
                            <!-- Sort by &nbsp;
                            <el-select @change='handleFilter' style="width: 200px" class="filter-item" v-model="listQuery.sort">
                              <el-option v-for="item in sortOptions" :key="item.key" :label="item.label" :value="item.key">
                              </el-option>
                            </el-select> -->
                        </div>
                    </div>
                    <div class="box-body">
                          <el-table v-loading="loadingModal" border hover
                          :data="tableData1"
                          style="width: 100%" max-height="550" responsive>
                          <el-table-column fixed="left"
                            label="#"
                            header-align="center"
                            align="center"
                            width="50px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.no}}.
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column fixed="left"
                            label="NOMOR PESAN"
                            prop="nomor_pb"
                            header-align="left"
                            align="left"
                            width="180px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_nomor_pb" placeholder="Filter Nomor Pesan" @keyup.native="cariNomorPB()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.nomor_pb }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="TOKO"
                            prop="toko"
                            header-align="left"
                            align="left">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_toko" placeholder="Filter Toko" @keyup.native="cariToko()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.toko }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="TANGGAL"
                            prop="tgl"
                            header-align="center"
                            align="center"
                            width="100px">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_tanggal" placeholder="Filter Tanggal" @keyup.native="cariTanggal()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.tgl }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="JAM"
                            prop="jam"
                            header-align="center"
                            align="center"
                            width="90px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{scope.row.jam}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="QTY"
                            prop="item_total"
                            header-align="center"
                            align="center"
                            width="80px">
                            <template slot-scope="scope">
                              <template v-if="!scope.row.edit">
                                {{toMoney(scope.row.item_total)}}
                              </template>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="DIBUAT OLEH"
                            prop="dibuat_oleh"
                            header-align="left"
                            align="left">
                            <template slot-scope="scope">
                              <template v-if="scope.row.edit">
                                <el-input v-model="cari_dibuat_oleh" placeholder="Filter Data" @keyup.native="caridibuat_oleh()"></el-input>
                              </template>
                              <span v-else>{{ scope.row.dibuat_oleh }}</span>
                            </template>
                          </el-table-column>
                          <el-table-column label="PILIHAN" align="center" header-align="center" width="100px">
                            <template slot-scope="scope">
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Ok" placement="top-start">
                                <el-button type="success" size="small" icon="el-icon-check"  @click="confirmEdit1(scope.$index, scope.row, ('form' + scope.$index))"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Detail" placement="top-start">
                                <el-button type="primary" size="small" icon="el-icon-search"  @click="confirmDet(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="scope.row.edit1" class="item" effect="dark" content="Cancel" placement="top-start">
                                <el-button size="small" icon="el-icon-error" type="warning" @click="cancelEdit(scope.$index, scope.row)"></el-button>
                              </el-tooltip>
                              <!-- <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Daftar Area" placement="top-start">
                                <el-button type="info" size="small" @click="confirmDet(scope.row)"><i class="material-icons" style="font-size: 10px;">location_city</i></el-button>
                              </el-tooltip>
                              <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Tambah Area" placement="top-start">
                                <el-button type="warning" size="small" icon="el-icon-plus" @click="confirmArea(scope.row)"></el-button>
                              </el-tooltip> -->
                              <!-- <el-tooltip v-if="!scope.row.edit" class="item" effect="dark" content="Hapus Region" placement="top-start">
                                <el-button type="danger" size="small" icon="el-icon-delete" @click="confirmDel(scope.row)"></el-button>
                              </el-tooltip> -->
                            </template>
                          </el-table-column>
                        </el-table>

                      <br/>

                        <div align="right">
                          <el-pagination
                            background
                            layout="prev, pager, next"
                            :total="tableData.length"
                            :page-size="page_size"
                            :current-page="current_page"
                            @current-change="handleCurrentChange" >
                          </el-pagination>
                        </div>


                    </div>
                </div>

                <el-dialog title="Tambah Region" :visible.sync="dialogFormVisible" v-loading="loadingModalAdd" width="35%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama" @keyup.enter.native="confirmEdit1(0, row1, 'formAdd')"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormVisible = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Edit Barang Item" :visible.sync="dialogFormItem" v-loading="loadingModalItem" width="35%" top="2%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formEdit" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Barang" prop="nama">
                      <el-input type="text" v-model="row1.nama" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="Qty" prop="qty">
                      <el-input type="text" v-model="row1.qty"></el-input>
                    </el-form-item>
                  </el-form>
                  <!-- <div class="pull-right"> -->
                    <el-row>
                      <el-col :span="10" class="grid-content">
                    <el-input
                      v-model="carinama"
                      placeholder="Pilih Barang"
                      @keyup.native="handleSelect"
                    ></el-input>
                  </el-col>
                    <el-col :span="4" class="grid-content">
                    </el-col>
                    <el-col :span="10" class="grid-content">
                      <div class="pull-right">
                        <el-button @click="dialogFormItem = false" block>Batal</el-button>
                        <el-button type="primary" @click="confirmEdit1(0, row1, 'formEdit')" block>Simpan</el-button>
                      </div>
                    </el-col>
                  </el-row>
                  <!-- </div> -->
                  <el-table border hover
                    ref="singleTable"
                    :data="pegawai"
                      highlight-current-row
                      @current-change="handleCurrentChangePegawai"
                    style="width: 100%" responsive>
                    <el-table-column fixed="left"
                      label="#"
                      header-align="center"
                      align="center"
                      width="50px">
                      <template slot-scope="scope">
                          {{scope.$index + 1}}.
                      </template>
                    </el-table-column>
                    <el-table-column
                      label="BARANG"
                      header-align="left"
                      align="left">
                      <template slot-scope="scope">
                          {{scope.row.nama}}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-dialog>

                <el-dialog title="Edit Barang Item" :visible.sync="dialogFormEdit" v-loading="loadingModalEdit" width="35%" top="2%">
                  <el-form :model="row1" status-icon :rules="rules3" ref="formAdd" :label-width="formLabelWidth" class="demo-ruleForm" @submit.prevent="">
                    <el-form-item label="Nama" prop="nama">
                      <el-input type="text" v-model="row1.nama" @keyup.enter.native="confirmEdit1(0, row1, 'formEdit')"></el-input>
                    </el-form-item>
                  </el-form>
                    <span slot="footer" class="dialog-footer">
                      <el-button @click="dialogFormEdit = false">Batal</el-button>
                      <el-button type="primary" @click="confirmEdit1(0, row1, 'formAdd')">Simpan</el-button>
                    </span>
                </el-dialog>

                <el-dialog title="Rincian Permintaan" :visible.sync="dialogFormPrintVisible" v-loading="loadingModalPrint" width="95%" top="2%">
                    <el-row>
                      <el-col :span="2">NOMOR</el-col>
                      <el-col :span="12">:&nbsp;&nbsp;&nbsp;{{ stok_nomor }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">TOKO</el-col>
                      <el-col :span="12">:&nbsp;&nbsp;&nbsp;{{ stok_toko }}</el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">DIBUAT OLEH</el-col>
                      <el-col :span="12">:&nbsp;&nbsp;&nbsp;{{ stok_dibuat_oleh }}</el-col>
                    </el-row>
                    <div class="pull-right">
                      <el-button type="warning" @click="addData()" size="small">Proses Menjadi Surat Jalan</el-button><br/>
                    </div>
                     <br /><br />
                    <el-table v-loading="loadingModal1" border hover
                      :data="tableData1_" id="kolom_permintaan"
                      style="width: 100%" responsive>
                      <el-table-column fixed="left"
                        label="#"
                        prop="no"
                        header-align="center"
                        align="center"
                        width="50px">
                      </el-table-column>

                      <el-table-column
                            header-align="center"
                            align="center"
                            label="PERMINTAAN">

                        <el-table-column
                          prop="sku"
                          label="SKU" 
                          header-align="center"
                          align="center"
                          width="100px">
                        </el-table-column>

                        <el-table-column
                          prop="nama_barang"
                          label="BARANG" 
                          header-align="center"
                          align="left">
                        </el-table-column>

                        <el-table-column
                          prop="qty"
                          label="QTY" 
                          header-align="center"
                          align="left"
                          width="120px">
                          <template slot-scope="scope">
                            {{ scope.row.qty }} {{ scope.row.satuan }}
                          </template>
                        </el-table-column>

                      </el-table-column>

                      <el-table-column 
                            header-align="center"
                            align="center"
                            label="DIKIRIM">

                        <el-table-column
                          prop="sku_dikirim"
                          label="SKU" 
                          header-align="center"
                          align="center"
                          width="100px">
                        </el-table-column>

                        <el-table-column
                          prop="nama_barang_dikirim"
                          label="BARANG" 
                          header-align="center"
                          align="left">
                        </el-table-column>

                        <el-table-column
                          prop="qty"
                          label="QTY" 
                          header-align="center"
                          align="left"
                          width="120px">
                          <template slot-scope="scope">
                            {{ scope.row.qty_dikirim }} {{ scope.row.satuan_dikirim }}
                          </template>
                        </el-table-column>

                      </el-table-column>

                      <!-- <el-table-column fixed="left"
                        label="SKU"
                        prop="sku">
                      </el-table-column>
                      <el-table-column
                        label="Barang"
                        prop="nama_barang">
                      </el-table-column>
                      <el-table-column
                        label="Qty">
                        <template slot-scope="scope">
                          {{ scope.row.qty }} {{ scope.row.satuan }}
                        </template>
                      </el-table-column>
                      <el-table-column fixed="left"
                        label="SKU dikirim"
                        prop="sku_dikirim">
                      </el-table-column>
                      <el-table-column
                        label="Barang Dikirim"
                        prop="nama_barang_dikirim">
                      </el-table-column>
                      <el-table-column
                        label="Qty Dikirim">
                        <template slot-scope="scope">
                          {{ scope.row.qty_dikirim }} {{ scope.row.satuan_dikirim }}
                        </template>
                      </el-table-column> -->
                      <el-table-column
                        label="SISA STOK"
                        prop="sisa_stok_toko"
                        header-align="center"
                        align="left"
                        width="150px"> 
                      </el-table-column>
                      <el-table-column
                        label="NOMOR DO"
                        prop="nomor_sj"
                        header-align="center"
                        align="center"
                        width="200px">  
                      </el-table-column>
                      <el-table-column label="PILIHAN" align="center" header-align="center" width="150px">
                        <template slot-scope="scope">
                          <el-tooltip class="item" effect="dark" content="Edit" placement="top-start">
                            <el-button size="small" icon="el-icon-edit" type="success" @click="confirmUpdate(scope.row)" :disabled="scope.row.nomor_sj !== ''"></el-button>
                          </el-tooltip>
                          <el-tooltip class="item" effect="dark" content="Cetak" placement="top-start">
                            <el-button size="small" icon="el-icon-printer" type="primary" @click="confirmCetak1(scope.row.cetak)" :disabled="scope.row.nomor_sj === ''"></el-button>
                          </el-tooltip>
                        </template>
                      </el-table-column>
                    </el-table>
                </el-dialog>

                <el-dialog title="Buat Surat Jalan" :visible.sync="dialogFormSJVisible" v-loading="loadingSJCetak" width="800px" top="1%">
                    <el-table v-loading="loadingModalSJ" border hover
                      :data="tableData1_1"
                      @selection-change="handleSelectionChange"
                      style="width: 100%" responsive>
                      <el-table-column fixed="left"
                        type="selection"
                        header-align="center"
                        align="center"
                        width="40px">
                      </el-table-column>                      
                      <el-table-column fixed="left"
                        label="#"
                        prop="no"
                        header-align="center"
                        align="center"
                        width="50px">
                      </el-table-column>

                      <el-table-column 
                            header-align="center"
                            align="center"
                            label="DATA PENGIRIMAN">

                        <el-table-column
                          prop="sku_dikirim"
                          label="SKU" 
                          header-align="center"
                          align="center"
                          width="100px">
                        </el-table-column>

                        <el-table-column
                          prop="nama_barang_dikirim"
                          label="BARANG" 
                          header-align="center"
                          align="left">
                        </el-table-column>

                        <el-table-column
                          prop="qty"
                          label="QTY" 
                          header-align="center"
                          align="left"
                          width="120px">
                          <template slot-scope="scope">
                            {{ scope.row.qty_dikirim }} {{ scope.row.satuan_dikirim }}
                          </template>
                        </el-table-column>

                      </el-table-column>

                      <!-- <el-table-column fixed="left"
                        label="SKU Dikirim"
                        prop="sku_dikirim">
                      </el-table-column>
                      <el-table-column
                        label="Barang Dikirim"
                        prop="nama_barang_dikirim">
                      </el-table-column>
                      <el-table-column
                        label="Qty Dikirim">
                        <template slot-scope="scope">
                          {{ scope.row.qty_dikirim }} {{ scope.row.satuan_dikirim }}
                        </template>
                      </el-table-column> -->
                    </el-table>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="success" @click="confirmSJ1()">Buat Surat Jalan Atas Barang Yang Sudah Dipilih/Dicentang</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Info" :visible.sync="dialogFormCetakVisible" v-loading="loadingModalCetak" width="810px" top="1%">
                  <div v-html="message"></div>
                  <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="dialogFormCetakVisible = false">OK</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Konfirmasi" :visible.sync="dialogFormWilDel" v-loading="loadingModalDel" width="500px" top="1%">
                  <h4>Apakah Anda yakin akan menghapus {{ nama }}?</h4>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormWilDel = false">Batal</el-button>
                    <el-button type="primary" @click="confirmDel1()">Ya</el-button>
                  </span>
                </el-dialog>

                <el-dialog title="Info" :visible.sync="dialogFormInfo" width="500px" top="1%">
                  <h5>{{ message }}</h5>
                  <span slot="footer" class="dialog-footer">
                    <!-- <el-button @click="dialogFormInfo = false">Batal</el-button> -->
                    <el-button type="primary" @click="dialogFormInfo = false">OK</el-button>
                  </span>
                </el-dialog>
                <!-- End of Basic Tables-->
                
            </section>
            <!-- /.content -->
        </div>
    </transition>
</template>
<script>
    import Vue from 'Vue'
    import VueResource from 'vue-resource'
    import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
    import VueCookie from 'vue-cookie'
    Vue.use(VueCookie)

    import jsonUrl from '../../../assets/url.json'

    Vue.use(VueResource)

    export default {
      name: 'Wilayah',
      components: {
        ClipLoader
      },
      data: function () {
        var validateName = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama wilayah'))
          } else {
            callback()
          }
        }
        var validateArea = (rule, value, callback) => {
          if (value === '') {
            callback(new Error('Silahkan isi nama area'))
          } else {
            callback()
          }
        }
        return {
          row1: {kode: '', nama: '', edit: true},
          kode_toko: '',
          pegawai: [],
          pegawai1: [],
          tableData: [],
          tableData1: [],
          tableData1_: [],
          tableData1_1: [],
          tableData2: [],
          cetak: '',
          cetak1: '',
          rules: {
            name: [
              { validator: validateName, trigger: 'blur' }
            ]
          },
          rules2: {
            area: [
              { validator: validateArea, trigger: 'blur' }
            ]
          },
          cari_nama: '',
          cari_jam: '',
          cari_tanggal: '',
          cari_dibuat_oleh: '',
          cari_diproses_gudang: '',
          cari_item_total: '',
          cari_nomor_pb: '',
          cari_toko: '',
          nama: '',
          coba: false,
          dialogFormEdit: false,
          dialogFormVisible: false,
          dialogFormWilEdit: false,
          dialogFormWilDel: false,
          dialogFormArea: false,
          loadingModal: false,
          loadingModalAdd: false,
          loadingModalEdit: false,
          loadingModalArea: false,
          loadingModalTambah: false,
          loadingModalDel: false,
          dialogFormInfo: false,
          dialogFormPrintVisible: false,
          loadingModalPrint: false,
          dialogFormCetakVisible: false,
          loadingModalCetak: false,
          dialogFormSJVisible: false,
          loadingSJCetak: false,
          loadingModalSJ: false,
          dialogFormItem: false,
          loadingModalItem: false,
          form: {
            kode: '',
            name: '',
            region: '',
            date1: '',
            date2: '',
            delivery: false,
            type: [],
            resource: '',
            desc: ''
          },
          form1: {
            kode: '',
            name: ''
          },
          form2: {
            kode: '',
            name: '',
            area: ''
          },
          message: '',
          formLabelWidth: 'auto',
          rules3: {
            nama: [
              { required: true, message: 'Silahkan isi nama wilayah', trigger: 'blur' }
            ]
          },
          listQuery: {
            page: 1,
            limit: 20,
            importance: undefined,
            title: undefined,
            type: undefined,
            sort: 'none'
          },
          sortOptions: [{ label: '--', key: 'none' }, { label: 'Nomor PB A-Z', key: '+nama' }, { label: 'Nomor PB Z-A', key: '-nama' }],
          total: null,
          page_size: 6,
          current_page: 1,
          stok_nomor: '',
          stok_toko: '',
          stok_dibuat_oleh: '',
          multipleSelection: []
        }
      },
      methods: {
        toMoney (x) {
          var parts = x.toString().split('.')
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          return parts.join('.')
        },
        handleSelect: function () {
          var nama = this.carinama
          var newArray = this.pegawai1.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.pegawai = newArray1.slice()
        },
        handleCurrentChangePegawai (val) {
          this.row1.nama = val.nama
          this.row1.kode_barang = val.kode
        },
        confirmUpdate (row) {
          this.dialogFormItem = true
          this.row1.nama = row.nama_barang_dikirim
          this.row1.qty = row.qty_dikirim
          this.row1.kode_barang = row.kode_barang_dikirim
          this.row1.kode_pemesanan_barang_item = row.kode_pemesanan_barang_item
        },
        confirmCetak2 (cetak) {
          var printContents = cetak
          var originalContents = document.body.innerHTML

          document.body.innerHTML = printContents

          window.print()

          document.body.innerHTML = originalContents
        },
        handleSelectionChange (val) {
          this.multipleSelection = val
        },
        confirmCetak1: function (cetak) {
          var left = ((screen.width / 2) - (800 / 2))
          var top = ((screen.height / 2) - (450 / 2))
          var mywindow = window.open('', 'CETAK DO', 'location=yes,height=450,width=900,scrollbars=yes,status=yes,top=' + top + ',left=' + left)

          mywindow.document.write(cetak)

          mywindow.document.close() // necessary for IE >= 10
          mywindow.focus() // necessary for IE >= 10*/
        },
        cariNama () {
          var nama = this.cari_nama
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nama
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariNomorPB () {
          var nama = this.cari_nomor_pb
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.nomor_pb
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariTanggal () {
          var nama = this.cari_tanggal + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.tgl + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariJam () {
          var nama = this.cari_jam + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.jam + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariToko () {
          var nama = this.cari_toko + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.toko + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        caridibuat_oleh () {
          var nama = this.cari_dibuat_oleh
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.dibuat_oleh
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        caridiproses_gudang () {
          var nama = this.cari_diproses_gudang
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.diproses_gudang
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        cariitem_total () {
          var nama = this.cari_item_total + ''
          var newArray = this.tableData2.slice()
          var newArray1 = newArray.filter(function (el) {
            var nama1 = el.item_total + ''
            return (nama1.toLowerCase().indexOf(nama.toLowerCase()) !== -1)
          })
          this.tableData = newArray1.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleFilter () {
          var byNama = this.tableData.slice(0)
          if (this.listQuery.sort === '+nama') {
            byNama.sort(function (a, b) {
              var x = a.nomor_pb.toLowerCase()
              var y = b.nomor_pb.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else if (this.listQuery.sort === '-nama') {
            byNama.sort(function (a, b) {
              var x = b.nomor_pb.toLowerCase()
              var y = a.nomor_pb.toLowerCase()
              return x < y ? -1 : x > y ? 1 : 0
            })
          } else {
            byNama = this.tableData2.slice(0)
          }
          this.tableData = byNama.slice()
          this.handleCurrentChange(this.current_page)
        },
        handleCurrentChange: function (val) {
          this.current_page = val
          this.tableData1 = []
          var a = (this.current_page - 1) * this.page_size
          var b = a + this.page_size
          if (b > this.tableData.length) {
            b = this.tableData.length
          }
          this.tableData1.push({kode: '', edit: true, nama: ''})
          for (var i = a; i < b; i++) {
            this.tableData1.push(this.tableData[i])
          }
        },
        submitForm: function (formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              alert('submit!')
            } else {
              console.log('error submit!!')
              return false
            }
          })
        },
        addData_: function () {
          // this.tableData1.unshift({kode: '', nama: '', edit: true})
          this.dialogFormVisible = true
          this.clearForm()
        },
        addData: function () {
          this.dialogFormSJVisible = true
        },
        clearForm: function () {
          this.row1 = {kode: '', nama: '', edit: true}
        },
        confirmDet: function (j, row) {
          this.dialogFormPrintVisible = true
          this.loadingModalPrint = true
          this.nomor_pb = row.nomor_pb
          this.kode_toko = row.kode_toko
          this.tableData1_1 = []

          var req = {nomor_pb: this.nomor_pb}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pemesanan_barang + '/detail'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (!response.body.keterangan) {
              this.loadingModalPrint = false
              this.stok_nomor = response.body.data[0].nomor_pb
              this.stok_toko = response.body.data[0].toko
              this.stok_dibuat_oleh = response.body.data[0].dibuat_oleh

              this.tableData1_ = response.body.data[0].item.slice()
              for (var i = 0; i < this.tableData1_.length; i++) {
                if (this.tableData1_[i].nomor_sj === '') {
                  this.tableData1_1.push(this.tableData1_[i])
                }
                this.getDataCetak(i)
                this.tableData1_[i].no = i + 1
              }
            } else {
              if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
                this.$router.push('/login')
              } else {
                this.loadingModalPrint = false
                this.stok_nomor = response.body.data[0].nomor_pb
                this.stok_toko = response.body.data[0].toko
                this.stok_dibuat_oleh = response.body.data[0].dibuat_oleh

                this.tableData1_ = response.body.data[0].item.slice()
              }
            }
          }, response => {
            // error callback
            this.loadingModalPrint = false
          })
        },
        getDataCetak (j) {
          var req = {nomor_sj: this.tableData1_[j].nomor_sj}
          var req1 = JSON.stringify(req)
          var url = Vue.cookie.get('url') + '/surat_jalan' + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (!response.body.keterangan) {
              this.loadingModalCetak = false
              var cetak = '<style> @media print { #printPageButton { display: none; }}  @page { size: auto;  margin: 0; } </style>' + '<pre>' + response.body + '</pre>' + '<br/><button id="printPageButton" onClick="window.print();">CETAK KE PRINTER</button>'
              this.tableData1_[j].cetak = cetak
            } else {
              if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
                this.$router.push('/login')
              } else {
                this.loadingModalCetak = false
              }
            }
          }, response => {
            // error callback
            this.loadingModalPrint = false
          })
        },
        confirmSJ1: function (row) {
          var items = []

          for (var i = 0; i < this.multipleSelection.length; i++) {
            items.push({kode_pemesanan_barang_item: this.multipleSelection[i].kode_pemesanan_barang_item + ''})
          }

          if (items.length > 0) {
            this.dialogFormSJVisible = true
            this.loadingModalSJ = true
            var req = {kode_toko: this.kode_toko, item: items}
            var req1 = JSON.stringify(req)

            var url = Vue.cookie.get('url') + '/surat_jalan' + '/create'

            Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
              // console.log('response ' + response.body[0].nama)
              if (!response.body.keterangan) {
                this.loadingModalSJ = false
                this.message = '<pre>' + response.body + '</pre>'
                this.dialogFormCetakVisible = true
                this.dialogFormSJVisible = false
                this.dialogFormPrintVisible = false
                this.confirmDet(0, {nomor_pb: this.nomor_pb, kode_toko: this.kode_toko})
              } else {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.loadingModalSJ = false
                  this.message = '<pre>' + response.body + '</pre>'
                  this.dialogFormCetakVisible = true
                  this.dialogFormSJVisible = false
                  this.confirmDet(0, {nomor_pb: this.nomor_pb, kode_toko: this.kode_toko})
                }
              }
            }, response => {
              // error callback
              this.loadingModalPrint = false
            })
          } else {}
        },
        confirmPrint1: function (row) {
          window.open(Vue.cookie.get('url') + '/print/surat_jalan', '_blank', 'location=yes,height=570,width=920,scrollbars=yes,status=yes')
        },
        confirmPrint: function (row) {
          this.dialogFormCetakVisible = true
          this.loadingModalCetak = true

          var req = {nomor_sj: row.nomor_sj}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/surat_jalan' + '/read'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (!response.body.keterangan) {
              this.loadingModalCetak = false
              /* eslint-disable */
              this.cetak = '<!DOCTYPE html><html><head><script type="text/javascript">window.print();<\/script><style> @media print { #printPageButton { display: none; }}  @page { size: auto;  margin: 0; } </style></head><body>' + '<pre>' + response.body + '</pre>' + '<button id="printPageButton" onClick="window.print();">Print</button></body></html>'
              /* eslint-enable */
              this.cetak1 = '<pre>' + response.body + '</pre>'
            } else {
              if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
                this.$router.push('/login')
              } else {
                this.loadingModalCetak = false
                this.cetak = response.body
              }
            }
          }, response => {
            // error callback
            this.loadingModalPrint = false
          })
        },
        confirmEdit: function (j, row) {
          this.dialogFormEdit = true
          this.row1.kode = row.kode
          this.row1.nama = row.nama
        },
        cancelEdit: function (j, row) {
          if (row.kode !== '') {
            row.nama = row.nama1
            var item = this.tableData1[j]
            item.edit = false
            this.$set(this.tableData1, j, item)
          } else {
            this.tableData1.splice(j, 1)
          }
        },
        confirmEdit1: function (j, row, formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.loadingModalItem = true
              this.dialogFormItem = false

              var req = ''
              var action = '/'
              req = {kode_barang: row.kode_barang, kode_pemesanan_barang_item: row.kode_pemesanan_barang_item + '', qty: row.qty}
              action += 'update'
              var req1 = JSON.stringify(req)

              var url = Vue.cookie.get('url') + '/' + jsonUrl.pemesanan_barang + action

              Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
                if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
                  this.$router.push('/login')
                } else {
                  this.dialogFormItem = false
                  this.getData()
                  this.loadingModalItem = false
                  // this.clearForm()
                  this.message = response.body
                  this.dialogFormInfo = true
                  // this.dialogFormCetakVisible = true
                  this.dialogFormSJVisible = false
                  this.dialogFormPrintVisible = false
                  this.confirmDet(0, {nomor_pb: this.nomor_pb, kode_toko: this.kode_toko})
                }
              }, response => {
                // error callback
                this.dialogFormItem = false
                this.loadingModalItem = false
                // this.dialogFormCetakVisible = true
                this.dialogFormSJVisible = false
                this.dialogFormPrintVisible = false
                this.confirmDet(0, {nomor_pb: this.nomor_pb, kode_toko: this.kode_toko})
                // this.clearForm()
              })
            } else {
              return false
            }
          })
        },
        confirmDel: function (row) {
          this.form1.kode = row.kode
          this.nama = row.nama
          this.dialogFormWilDel = true
        },
        confirmDel1: function () {
          this.loadingModalDel = true
          var req = {kode: this.form1.kode}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pemesanan_barang + '/delete'

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + JSON.stringify(response.body))
            // if (response.body.status === "SUCCESS") {}
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.dialogFormWilDel = false
              this.loadingModalDel = false
              this.getData()
              this.message = response.body
              this.dialogFormInfo = true
              this.clearForm()
            }
          }, response => {
            // error callback
            this.dialogFormWilDel = false
            this.loadingModalDel = false
            this.clearForm()
          })
          // this.dialogFormWilDel = false
        },
        getData: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var c = this.current_page
          var req = ''
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.pemesanan_barang + '/read'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.keterangan.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.loadingModal = false
              this.tableData = response.body.data
              this.total = this.tableData.length
              for (var i = 0; i < this.tableData.length; i++) {
                this.tableData[i].edit = false
                this.tableData[i].no = i + 1
              }
              this.tableData2 = this.tableData.slice()
              var a = 0
              var b = a + this.page_size
              if (b > this.tableData.length) {
                b = this.tableData.length
              }
              for (var j = a; j < b; j++) {
                this.tableData1.push(this.tableData[j])
              }
              this.current_page = c
              this.handleCurrentChange(c)
            }
          }, response => {
            // error callback
            this.loadingModal = false
          })
        },
        getData1: function () {
          // this.loadingModal = true
          this.tableData = []
          this.tableData1 = []
          var req = {}
          var req1 = JSON.stringify(req)

          var url = Vue.cookie.get('url') + '/' + jsonUrl.barang + '/read_simple'
          // console.log(localStorage.session)

          Vue.http.post(url, req1, {headers: {'Content-Type': 'application/json', 'Session': localStorage.session}}).then(response => {
            // console.log('response ' + response.body[0].nama)
            if (response.body.keterangan.toString().indexOf('Session Expired') > -1 || response.body.toString().indexOf('Authorization required') > -1) {
              this.$router.push('/login')
            } else {
              this.pegawai = response.body.data.slice()
              for (var i = 0; i < this.pegawai.length; i++) {
                this.pegawai[i].kode = this.pegawai[i].kode + ''
              }
              this.pegawai1 = this.pegawai.slice()
            }
          }, response => {
            // error callback
          })
        }
      },
      mounted () {
        // if (localStorage.username !== 'root') {
        //   this.$router.replace('/toko')
        // }
        this.loadingModal = true
        this.getData()
        this.getData1()
      }
    }
</script>

<style>
  @media print {
    body * {
      visibility: hidden;
    }
    #print * {
      visibility: visible;
    }
    #print {
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  @page { 
    size: auto;
    margin: 0;
  }
  .edit-input {
    padding-right: 100px;
  }
  .cancel-btn {
    position: absolute;
    right: 15px;
    top: 10px;
  }
  /* #kolom_permintaan.el-table thead.is-group th {
    background: #ffddc4 !important;
  } */
</style>



// WEBPACK FOOTER //
// PemesananBarang1.vue?7c64e8b0